import { ArrowDown01Icon } from "@hugeicons/core-free-icons"
import { HugeiconsIcon } from "@hugeicons/react"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@motleyhand/design"
import { useNavigate } from "@tanstack/react-router"
import { useState } from "react"
import {
  useCurrentTenant,
  useGetTenantsQuery,
  useUpdateSettingsMutation,
} from "@/tenant"

export default function TenantSelect() {
  const { tenantSlug, tenant } = useCurrentTenant()
  const navigate = useNavigate()
  const { data: tenants } = useGetTenantsQuery()
  const [updateSettings] = useUpdateSettingsMutation()
  const [open, setOpen] = useState(false)

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu open={open} onOpenChange={setOpen}>
          <DropdownMenuTrigger
            render={
              <SidebarMenuButton>
                <span className="group-data-[state=collapsed]:hidden">
                  {tenant?.name}
                </span>
                <HugeiconsIcon icon={ArrowDown01Icon} className="ml-auto" />
              </SidebarMenuButton>
            }
          />
          <DropdownMenuContent>
            <DropdownMenuRadioGroup
              value={tenantSlug}
              onValueChange={async (slug: string) => {
                setOpen(false)
                await navigate({
                  to: "/t/$tenantSlug/dashboard",
                  params: { tenantSlug: slug },
                })
                await updateSettings({
                  currentTenantSlug: slug,
                })
              }}
            >
              {tenants?.map(({ slug, name }) => (
                <DropdownMenuRadioItem key={slug} value={slug}>
                  {name}
                </DropdownMenuRadioItem>
              ))}
            </DropdownMenuRadioGroup>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              onClick={async () => {
                await navigate({ to: "/onboarding" })
              }}
            >
              New Workspace
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  )
}
